import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { MountedRelationalDatabaseLinkedService } from '../linkedservice/mounted-relational-database.linkedservice';


@Metamodel.model({
    name: ModelConstants.mountedRelationalDatabaseDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.MountedRelationalDatabase_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.MountedRelationalDatabase_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MountedRelationalDatabaseLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MountedRelationalDatabaseTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
